import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isValidJson',
})
export class IsValidJsonPipe implements PipeTransform {
  transform(value: string): boolean {
    try {
      JSON.parse(value);
      return true;
    } catch {
      return false;
    }
  }
}
